var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFrame = function SvgFrame(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38 38",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M24.2 12H2.301a1.8 1.8 0 0 1-1.8-1.8V1.8a1.8 1.8 0 0 1 1.8-1.8H36.2A1.8 1.8 0 0 1 38 1.8v33.901a1.8 1.8 0 0 1-1.8 1.8h-8.4a1.8 1.8 0 0 1-1.8-1.8V13.8a1.8 1.8 0 0 0-1.8-1.8Z"
  })));
};
export default SvgFrame;